import Select from "../../../components/Form/Select";
import { useTranslationApp } from "../../../lib/i18next";
import {
  TEMPLATES_ORIENTATION,
  TEMPLATES_ORIENTATION_HORIZONTAL,
  TEMPLATES_ORIENTATION_VERTICAL,
  TEMPLATES_ORIENTATION_VERTICAL_UP,
} from "../../../i18n/keysTranslations";
import { TEXT_ORIENTATION } from "../utils/textOrientation";

const optionalRules = { required: false };

const TextOrientationSelect = ({
  control,
  errors,
  disabled,
  onChangeField,
  name = "orientation",
}) => {
  const { t } = useTranslationApp();
  return (
    <Select
      control={control}
      errors={errors}
      name={name}
      label={t(TEMPLATES_ORIENTATION)}
      variant="filled"
      fullWidth
      disabled={disabled}
      rules={optionalRules}
      actionsChange={(value) => onChangeField({ key: "orientation", value })}
      options={[
        {
          value: TEXT_ORIENTATION.HORIZONTAL,
          label: t(TEMPLATES_ORIENTATION_HORIZONTAL),
        },
        {
          value: TEXT_ORIENTATION.VERTICAL,
          label: t(TEMPLATES_ORIENTATION_VERTICAL),
        },
        {
          value: TEXT_ORIENTATION.VERTICAL_UP,
          label: t(TEMPLATES_ORIENTATION_VERTICAL_UP),
        },
      ]}
    />
  );
};

export default TextOrientationSelect;
